export const getLastAttachmentIdByRequirement = (messages) => {
    var _a;
    const map = new Map();
    for (const message of messages) {
        for (const att of (_a = message.attachments) !== null && _a !== void 0 ? _a : []) {
            if (att.type !== 'lab_results')
                continue;
            if (!att.attachment_requirement_id)
                continue;
            map.set(att.attachment_requirement_id, att.id);
        }
    }
    return map;
};
export const isLastAttachmentForRequirement = (attachment, lastMap) => {
    const reqId = attachment.attachment_requirement_id;
    if (!reqId)
        return false;
    return lastMap.get(reqId) === attachment.id;
};
